import ChoiceButton from './ChoiceButton';

export default ChoiceButton;
